// =============================================================================
// 비밀번호 변경 실패 문구 — 서버 코드 하나를 화면 여러 곳이 같은 말로 옮긴다.
//
// 2026-09-17 대교 보고: 초기 비밀번호와 같은 값으로 바꾸려 했더니 "현재 비밀번호를
// 확인하라"고만 나왔다. 서버는 재사용을 정확히 거부하고 있었는데(`password_reuse`),
// 조직 관리 화면이 403이면 무조건 "현재 비밀번호가 올바르지 않습니다"로 바꾸고 있었고
// 첫 로그인 화면은 아는 코드가 아니면 뭉뚱그린 문구로 떨어뜨렸다. 매핑을 한 곳에 둔다.
// =============================================================================

const MESSAGES: Record<string, string> = {
  password_reuse: '새 비밀번호가 현재 비밀번호와 같습니다. 다른 비밀번호를 입력해 주세요.',
  account_locked: '로그인 시도가 잠겼습니다. 15분 후 다시 시도하거나 관리자에게 문의해 주세요.',
  'current password is incorrect': '현재 비밀번호를 확인해 주세요.',
  invalid_credentials: '현재 비밀번호를 확인해 주세요.',
};

/** 서버가 준 오류 코드/문장을 사용자 문구로. 모르는 값이면 뭉뚱그리지 말고 기본 안내. */
export function describePasswordError(raw: unknown): string {
  const code = typeof raw === 'string' ? raw : '';
  if (MESSAGES[code]) return MESSAGES[code]!;
  // 코드가 문장 안에 섞여 오는 경로(Error 메시지 등)도 건져 낸다.
  const hit = Object.keys(MESSAGES).find((key) => code.includes(key));
  if (hit) return MESSAGES[hit]!;
  return '비밀번호를 변경하지 못했습니다. 입력 내용을 확인해 주세요.';
}

/** 제출 전에 화면이 스스로 막는 경우의 이유 — 버튼이 왜 안 눌리는지 말해 준다. */
export const PASSWORD_REUSE_HINT = '새 비밀번호는 현재 비밀번호와 달라야 합니다.';
